module.exports = __webpack_public_path__ + "static/media/Logo.d1c18012.svg";